export const IconBulletListItem20: {
  name: 'icon_bullet_list_item_20-7b82eca7dfd9'
} = {
  name: 'icon_bullet_list_item_20-7b82eca7dfd9'
}
